

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { CombosContext } from '../../context/combo/ComboContext';
import { StocksContext } from '../../context/stock/StockContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';


 

export const ComboPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);    
    const { addCombo, updateCombo } = useContext(CombosContext);
    const { stocks } = useContext(StocksContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState(''); 
    const [isUpdate, setIsUpdate] = useState(false);   
    const [unitName, setUnitName] = useState('');

    var product ;
    var combo ;

    if(state){
        product = state.product;

        if(state.combo){
            combo = state.combo;
            if(!isUpdate){
                setIsUpdate(true);
                const currentStock = stocks.find((stock)=>stock.id == combo.stockId);
                if(currentStock != undefined){
                    setUnitName(currentStock.unit);
                }
            }
            
                
        }else{
            combo = {
                stockId: -1,
                quantity: ''
            }
        }
        
    }
    
   
    const {formState, onInputChange } = useForm(combo);

   const {stockId, quantity } = formState

   useEffect(() =>{
     const formValid =  stockId > 0 && quantity.length > 0 
     setIsFormValid(formValid);
   }, [stockId, quantity])

   useEffect(() =>{
    const currentStock = stocks.find((stock)=>stock.id == stockId);
    if(currentStock != undefined){
        setUnitName(currentStock.unit);
    }
        
  }, [stockId])

  useEffect(() =>{
    const currentStock = stocks.find((stock)=>stock.id == stockId);
    if(currentStock != undefined){
        setUnitName(currentStock.unit);
    }
        
  }, [stocks])

    const handleSave = async ()=>{
        if (!isFormValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return;
        }

        var resp = "";
        if( isUpdate) {            
            resp = await updateCombo( product.id, combo.stockId, formState );
        } else {
            formState.productId = product.id;
            resp = await addCombo(formState);
        }
        if(resp == "success"){
            setSuccessMessage(isUpdate ? "Producto actualizado correctamente" : "Producto creado correctamente.");            
        }else{
            setErrorMessage(resp);
        }
    }

    const removeError = ()=>{
        setErrorMessage('');
       }

       const removeSucessMessage = ()=>{
        setSuccessMessage('');
        navigate(-1);
       }

    return (
        
        <div className='container d-flex align-items-center justify-content-center mt-5' style={ styles.container }>
            

            <div className='col-md-6'>
            <h3>{ combo.status != null  ? 'Actualizar cantidad' : 'Agregar producto'}</h3> 
            <hr />

            <form className="row g-3 " >

           
            <div className="mb-3">
                    <label htmlFor="stockSelect" className="form-label">Producto inventario *</label>
                    <select id='stockSelect' className={`form-select${required.mark(!(stockId > 0))}`} name='stockId' value={stockId} onChange={ onInputChange } disabled={isUpdate} >
                    <option key={0} value={-1} >Seleccione una opción</option>
                    {stocks.length > 0 
                    ?
                    stocks.map(stock => (
                        <option key={stock.id} value={stock.id} >{stock.name}</option>
                      ))
                    :
                    <option selected>No hay productos en inventario</option>
                    }
                   </select>
                    <div className="invalid-feedback">Campo requerido</div>
                </div>
           
                <div className="mb-3">
                    <label htmlFor="quantityInput" className="form-label">Cantidad *</label>
                    <div className="input-group has-validation mb-3">
                    <input 
                        id='quantityInput'
                        type="text" 
                        className={`form-control${required.mark(!quantity)}`}
                        placeholder="Cantidad"
                        name="quantity"
                        value={ quantity }
                        onChange={ onInputChange }
                        required
                        aria-describedby="basic-addon2"
                    />
                    <span className="input-group-text" id="basic-addon2">{unitName}</span>
                    <div className="invalid-feedback">Campo requerido</div>
                    </div>
                    
                </div>

                

               
                
                <div className='container d-flex align-items-center justify-content-center mt-5'>
                    <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                    <button type="button" onClick={handleSave} className="btn btn-primary ms-5">Guardar</button>
    </div>
                </form>
                <div style={{height: '100px'}}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)'/> : ''
            }
            
            

        </div>
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
